/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetExchangesResponse,
  UtxExchangesFilterTransferParams,
  PostRfqResponse,
  PostRfqRequest,
  PostRfqExecutionResponse,
  PostRfqExecutionRequest,
  GetUserGetRecentTradesResponse,
  UtxExchangesUserGetRecentTradesParams,
  GetDefaultRfqResponse,
  UtxExchangesUserGetDefaultRfqParams
} from './schema'



/**
 * Get user exchange history
 */
export const utxExchangesFilterTransfer = (
    params?: UtxExchangesFilterTransferParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetExchangesResponse[]>> => {
    return axios.get(
      `/exchanges`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxExchangesFilterTransferQueryKey = (params?: UtxExchangesFilterTransferParams,) => [`/exchanges`, ...(params ? [params]: [])];

    
export type UtxExchangesFilterTransferQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangesFilterTransfer>>>
export type UtxExchangesFilterTransferQueryError = AxiosError<void>

export const useUtxExchangesFilterTransfer = <TData = Awaited<ReturnType<typeof utxExchangesFilterTransfer>>, TError = AxiosError<void>>(
 params?: UtxExchangesFilterTransferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangesFilterTransfer>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangesFilterTransferQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangesFilterTransfer>>> = ({ signal }) => utxExchangesFilterTransfer(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangesFilterTransfer>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Request rfq
 */
export const utxExchangesObtainRfq = (
    postRfqRequest: PostRfqRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostRfqResponse>> => {
    return axios.post(
      `/exchanges/rfq`,
      postRfqRequest,options
    );
  }



    export type UtxExchangesObtainRfqMutationResult = NonNullable<Awaited<ReturnType<typeof utxExchangesObtainRfq>>>
    export type UtxExchangesObtainRfqMutationBody = PostRfqRequest
    export type UtxExchangesObtainRfqMutationError = AxiosError<unknown>

    export const useUtxExchangesObtainRfq = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxExchangesObtainRfq>>, TError,{data: PostRfqRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxExchangesObtainRfq>>, {data: PostRfqRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxExchangesObtainRfq(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxExchangesObtainRfq>>, TError, {data: PostRfqRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Execute the Rfq
 */
export const utxExchangesUserExecuteRfq = (
    postRfqExecutionRequest: PostRfqExecutionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostRfqExecutionResponse>> => {
    return axios.post(
      `/exchanges/rfq/execute`,
      postRfqExecutionRequest,options
    );
  }



    export type UtxExchangesUserExecuteRfqMutationResult = NonNullable<Awaited<ReturnType<typeof utxExchangesUserExecuteRfq>>>
    export type UtxExchangesUserExecuteRfqMutationBody = PostRfqExecutionRequest
    export type UtxExchangesUserExecuteRfqMutationError = AxiosError<unknown>

    export const useUtxExchangesUserExecuteRfq = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxExchangesUserExecuteRfq>>, TError,{data: PostRfqExecutionRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxExchangesUserExecuteRfq>>, {data: PostRfqExecutionRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxExchangesUserExecuteRfq(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxExchangesUserExecuteRfq>>, TError, {data: PostRfqExecutionRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get user recent trades
 */
export const utxExchangesUserGetRecentTrades = (
    params: UtxExchangesUserGetRecentTradesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserGetRecentTradesResponse>> => {
    return axios.get(
      `/exchanges/recent`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxExchangesUserGetRecentTradesQueryKey = (params: UtxExchangesUserGetRecentTradesParams,) => [`/exchanges/recent`, ...(params ? [params]: [])];

    
export type UtxExchangesUserGetRecentTradesQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangesUserGetRecentTrades>>>
export type UtxExchangesUserGetRecentTradesQueryError = AxiosError<unknown>

export const useUtxExchangesUserGetRecentTrades = <TData = Awaited<ReturnType<typeof utxExchangesUserGetRecentTrades>>, TError = AxiosError<unknown>>(
 params: UtxExchangesUserGetRecentTradesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangesUserGetRecentTrades>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangesUserGetRecentTradesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangesUserGetRecentTrades>>> = ({ signal }) => utxExchangesUserGetRecentTrades(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangesUserGetRecentTrades>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get Default Rfq
 */
export const utxExchangesUserGetDefaultRfq = (
    params?: UtxExchangesUserGetDefaultRfqParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetDefaultRfqResponse>> => {
    return axios.get(
      `/exchanges/default-rfq`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxExchangesUserGetDefaultRfqQueryKey = (params?: UtxExchangesUserGetDefaultRfqParams,) => [`/exchanges/default-rfq`, ...(params ? [params]: [])];

    
export type UtxExchangesUserGetDefaultRfqQueryResult = NonNullable<Awaited<ReturnType<typeof utxExchangesUserGetDefaultRfq>>>
export type UtxExchangesUserGetDefaultRfqQueryError = AxiosError<unknown>

export const useUtxExchangesUserGetDefaultRfq = <TData = Awaited<ReturnType<typeof utxExchangesUserGetDefaultRfq>>, TError = AxiosError<unknown>>(
 params?: UtxExchangesUserGetDefaultRfqParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxExchangesUserGetDefaultRfq>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxExchangesUserGetDefaultRfqQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxExchangesUserGetDefaultRfq>>> = ({ signal }) => utxExchangesUserGetDefaultRfq(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxExchangesUserGetDefaultRfq>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

